import { isEmpty } from "lodash";

import { objectKeys } from "app/helpers/objects";
import { getEntryWithTypeFactory } from "app/pages/sales-intelligence/sub-modules/advanced-search/helpers/technologies";
import type { TechnologiesConditionEntry } from "app/pages/sales-intelligence/sub-modules/advanced-search/models/filters/technology/types";
import type TechnologySignalTechnologiesFilters from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalTechnologiesFilters";
import { filterToEntryTypeMap } from "app/pages/sales-intelligence/sub-modules/signals/utils/technologies/filterEntryTypeMaps";

export const buildEntriesFromFilter = (
    initialFilterValue: Partial<TechnologySignalTechnologiesFilters>,
): ReadonlyArray<TechnologiesConditionEntry> => {
    let entries: ReadonlyArray<TechnologiesConditionEntry> = [];
    const keys = objectKeys(initialFilterValue);

    for (const filterKey of keys) {
        const filterValue = initialFilterValue[filterKey];

        if (Array.isArray(filterValue) && !isEmpty(filterValue)) {
            const entryType = filterToEntryTypeMap[filterKey];
            const entriesOfType = filterValue.map(getEntryWithTypeFactory(entryType));

            entries = [...entries, ...entriesOfType];
        }
    }

    return entries;
};
